import { DocumentUploadResponse } from '../../types/chatTypes'
import { axiosClient } from '../axiosClient'

export const documentFunctions = {
  uploadDocument: async (
    file: File,
  ): Promise<DocumentUploadResponse> => {
    const formData = new FormData()
    formData.append('file', file)

    return await axiosClient.post('api/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      // The attachment chip shows the failure.
      suppressErrorToast: true,
      // Parallel attachment uploads share the connection.
      timeout: 120000,
    })
  },

  deleteDocument: async (
    documentId: string,
  ): Promise<void> => {
    await axiosClient.delete<void>(`api/documents/${documentId}`)
  },

  downloadDocument: async (
    documentId: string,
  ): Promise<Blob> => {
    return await axiosClient.get(`api/documents/${documentId}/download`, {
      responseType: 'blob',
    })
  },

  // Fetch an extracted asset (e.g. a figure/image crop) as a Blob. The asset
  // endpoint is Bearer-authed, so an `<img src>` cannot load it directly — the
  // caller turns this Blob into an object URL. `assetPath` is the same-origin
  // path embedded in answer markdown, e.g. `/api/assets/{domain}/{blob_path}`;
  // the leading slash is normalised away to match the axios baseURL convention
  // used across the API modules.
  fetchAssetBlob: async (
    assetPath: string,
  ): Promise<Blob> => {
    return await axiosClient.get(assetPath.replace(/^\/+/, ''), {
      responseType: 'blob',
      // AssetImage renders its own inline fallback on failure — a missing
      // image must not fire the global error toast.
      suppressErrorToast: true,
    })
  },
}
